import { apiDelete, apiGet, apiPatch, apiPost, apiPut, apiUpload } from "./api";

export function getBlogs(params = {}) {
  return apiGet("/cms/blog/posts/", params);
}

export function getFeaturedBlogs(params = {}) {
  return apiGet("/cms/blog/posts/", { ...params, is_featured: true });
}

export function getBlogBySlug(slug) {
  return apiGet(`/cms/blog/posts/${slug}/`);
}

export function getBlogById(id) {
  return apiGet(`/cms/admin/blog/posts/${id}/`);
}

export function getAdminBlogs(params = {}) {
  return apiGet("/cms/admin/blog/posts/", params);
}

export function createBlog(payload) {
  return apiPost("/cms/admin/blog/posts/", payload);
}

export function updateBlog(id, payload) {
  return apiPut(`/cms/admin/blog/posts/${id}/`, payload);
}

export function patchBlog(id, payload) {
  return apiPatch(`/cms/admin/blog/posts/${id}/`, payload);
}

export function deleteBlog(id) {
  return apiDelete(`/cms/admin/blog/posts/${id}/`);
}

export function getBlogCategories(params = {}) {
  return apiGet("/cms/blog/categories/", params);
}

export function createCategory(payload) {
  return apiPost("/cms/admin/blog/categories/", payload);
}

export function uploadMedia(formData) {
  return apiUpload("/media/upload/", formData);
}